<template>
    <div class="app">
        <div class="bra">
            <div class="center">
                <router-link to="/"><img class="logos" src="../../assets/images/logo.png" alt="天天短网址"></router-link>
                <div><router-link to="/exlcusiveDomain"><i class="iconfont iconyuming1"></i> 专属域名介绍</router-link></div>
                <div><router-link to="/apidoc"><i class="iconfont iconapi"></i> API文档</router-link></div>

                <div v-if="isGuest"><router-link to="/reg" onclick="_czc.push(['_trackEvent', '主页按钮', '点击', '注册','1','dafen'])"><i class="iconfont iconzhuce-"></i> 注册</router-link></div>
                <div v-if="isGuest"><router-link to="/login" onclick="_czc.push(['_trackEvent', '主页按钮', '点击', '登入','1','dafen'])"><i class="iconfont iconyonghu"></i> 登入</router-link></div>
                <div v-if="isGuest"><router-link to="/recording" onclick="_czc.push(['_trackEvent', '主页按钮', '点击', '转换记录','1','dafen'])"><i class="iconfont iconjilu2"></i> 转换记录</router-link></div>
                <div v-else class="profile">
                    <router-link to="/tabs/index">
                        <img :src="user_info.profile" alt="用户头像">
                        <span v-show="isVip"><i class="iconfont iconVIP gold"></i></span>
                        <span style="padding-left: 2px">{{user_info.nickname}}</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="mid">
            <div class="ed-header">
                <div class="ed-filter box-sizing" v-if="isShowTime">
                    <span>时间：</span>
                    <span>
                        <el-date-picker
                                v-model="timeGroup"
                                type="daterange"
                                unlink-panels
                                value-format="timestamp"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :editable="false"
                                :picker-options="pickerOptions"
                                :default-time="['00:00:00', '23:59:59']"
                                @change="init">
                        </el-date-picker>
                    </span>
                </div>
                <div class="ed-filter box-sizing" v-else>
                    <el-alert title="非VIP用户只能查看当天数据，VIP用户可查看历史30天数据。" type="warning" show-icon :closable="false"></el-alert>
                </div>
                <div class="ed-link box-sizing">
                    <span>短网址：</span>
                    <a class="link1" :href="new_url" target="_blank">{{new_url}}</a>
                    <span>原网址：</span>
                    <a class="link2" :href="org_url" target="_blank">{{org_url}}</a>
                    <span>备注：{{url_mark}}</span>
                </div>
            </div>
            <div class="access-data">
                <div class="ad-item">
                    <div class="l-icon bg-blue"><i class="iconfont iconshuju1"></i></div>
                    <div class="m-data">
                        <div class="m-text">总访问量（PV）</div>
                        <div class="m-num ellipsis">{{pv_total}}</div>
                    </div>
                </div>
                <div class="ad-item middle">
                    <div class="l-icon bg-green"><i class="iconfont iconuvip"></i></div>
                    <div class="m-data">
                        <div class="m-text">总访独立用户数（UV）</div>
                        <div class="m-num ellipsis">{{uv_total}}</div>
                    </div>
                </div>
                <div class="ad-item">
                    <div class="l-icon bg-red"><i class="iconfont iconshebei3"></i></div>
                    <div class="m-data">
                        <div class="m-text">总IP数</div>
                        <div class="m-num ellipsis">{{ip_total}}</div>
                    </div>
                </div>
            </div>
            <div class="chart-box1" ref="lineChart"></div>
            <div class="chart-box1">
                <div class="pie-chart" ref="pieChart"></div>
                <div class="bar-chart">
                    <div class="title">客户端TOP5</div>
                    <div class="subtext">数据来源：天天短网址</div>
                    <div class="progress">
                        <div v-for="(item,index) in devTop">
                            <div class="lab">{{item.name}}</div>
                            <el-progress :text-inside="true" :stroke-width="25" :percentage="item.value" :color="devTopColor[index]"></el-progress>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chart-box1" ref="broChart"></div>
            <div class="chart-box2" ref="mapChart"></div>
            <div class="chart-box2" ref="torChart"></div>
            <div class="record-box">
                <div class="title">高频访问IP名单 TOP 10</div>
                <div class="subtext">数据来源：天天短网址</div>
                <div class="content">
                    <el-table :data="ipRecord" empty-text="暂无数据">
                        <el-table-column prop="ip" label="IP"></el-table-column>
                        <el-table-column prop="visits" label="访问次数"></el-table-column>
                        <el-table-column label="IP归属地">
                            <template slot-scope="scope">{{scope.row.address}}-{{scope.row.isp}}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="record-box">
                <div class="title">访问记录明细</div>
                <div class="subtext">数据来源：天天短网址</div>
                <div class="content">
                    <el-table v-loading="isLoading" :data="accessRecord" empty-text="暂无数据">
                        <el-table-column prop="time" label="时间" width="170"></el-table-column>
                        <el-table-column prop="dev" label="设备" width="140"></el-table-column>
                        <el-table-column prop="browser" label="浏览器" width="140"></el-table-column>
                        <el-table-column prop="ip" label="IP" width="140"></el-table-column>
                        <el-table-column prop="source_domain" label="访问来源"></el-table-column>
                        <el-table-column label="IP归属地">
                            <template slot-scope="scope">{{scope.row.area}}-{{scope.row.isp}}</template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagebar" v-show="accessRecordTotal>0">
                    <el-pagination background layout="total, prev, pager, next, jumper" :total="accessRecordTotal" @current-change="handleCurrentPage"></el-pagination>
                </div>
            </div>
        </div>
        <div class="footer">Copyright &copy; 2018-2020  版权所有</div>
    </div>
</template>

<script>
    import chart from "../../utils/chart";
    export default {
        name: "Statistics",
        data() {
            return {
                id: 0,
                isVip: false,
                isGuest: true,
                new_url: '未知',
                org_url: '未知',
                url_mark: '未知',
                pv_total: 0,
                uv_total: 0,
                ip_total: 0,
                currentPage: 1,
                user_info: {},
                timeGroup: [],
                devTop: [],
                devTopColor: ["#049dff","#fdba04","#1abc9c","#ed687c","#99cc66"],
                ipRecord: [],
                isLoading: false,
                isShowTime: false,
                accessRecord: [],
                accessRecordTotal: 0,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;

            this.id = this.$route.params.id;
            if (token !== null && token !== '' && token !== undefined) {
              console.log("is vip :",Number(user_info.expire_date) > times);
                if (Number(user_info.expire_date) > times){
                    this.isVip = true;
                    this.isShowTime = true;
                    console.log('is_show_time');
                }
                this.isGuest = false;
                this.user_info = user_info;
            }
            setTimeout(this.init,200);
        },
        methods: {
            async getInitialData() {
                let start = 0;
                let end = 0;
                if (this.timeGroup === null) this.timeGroup = [];
                if (this.timeGroup.length === 2){
                    start = this.timeGroup[0];
                    end = this.timeGroup[1];
                }
                const getData = {
                    id: this.id,
                    start: Number(start/1000),
                    end: Number(end/1000),
                };
                const {ret,data} = await this.$api.shortUrl.getInitialData(getData);
                if (ret === 1000){
                    console.log(data);
                    this.org_url = data.url;
                    this.new_url = data.new_url;
                    this.url_mark = data.mark;
                    this.pv_total = data.total_pv;
                    this.uv_total = data.total_uv;
                    this.ip_total = data.total_ip;
                    this.devTop = data.devTop;
                    this.ipRecord = data.ip_record;
                    //this.isShowTime = data.is_exclusive === 1;
                    this.initChart(data);
                }
            },
            async getAccessRecord() {
                let start = 0;
                let end = 0;
                if (this.timeGroup === null) this.timeGroup = [];
                if (this.timeGroup.length === 2){
                    start = this.timeGroup[0];
                    end = this.timeGroup[1];
                }
                const getData = {
                    id: this.id,
                    start: Number(start/1000),
                    end: Number(end/1000),
                    p: this.currentPage,
                };
                this.isLoading = true;
                const {ret,data} = await this.$api.shortUrl.getAccessRecord(getData);
                this.isLoading = false;
                if (ret === 1000){
                    this.accessRecord = data.list;
                    this.accessRecordTotal = Number(data.total);
                }
            },
            async init() {
                await this.getInitialData();
                await this.getAccessRecord();
            },
            initChart(data) {
                chart.chartPv(this.$refs.lineChart,data.access);
                chart.chartDev(this.$refs.pieChart,data.dev);
                chart.chartBro(this.$refs.broChart,data.bro);
                chart.chartMap(this.$refs.mapChart,data.map);
                chart.chartTor(this.$refs.torChart,data.isp);
            },
            handleCurrentPage(val) {
                console.log(val);
                this.currentPage = val;
                this.getAccessRecord();
            },
        },
    }
</script>

<style scoped>
    .ml-10{
        margin-left: 10px;
    }
    .app{
        height: auto;
        background-color: #f5f5f5;
    }
    .bra {
        width: 100%;
        height: 80px;
        background-color: #008DF2;
    }
    .bra .center {
        width: 1200px;
        height: 80px;
        margin: 0 auto;
        line-height: 80px;
        position: relative;
        text-align: right;
        color: #ffffff;
        background-color: #008DF2;
    }
    .bra .center .logos {
        width: 130px;
        height: 50px;
        position: absolute;
        top: 15px;
        left: 10px;
    }
    .bra .center div {
        display: inline-block;
        margin: 0 10px;
        vertical-align: top;
    }
    .bra .center .profile {
        height: 100%;
        text-align: left;
    }
    .bra .center .profile img {
        width: 40px;
        height: 40px;
        border-radius: 50px;
        margin-top: 20px;
        vertical-align: top;
    }
    .bra .center .profile span {
        height: 80px;
        display: inline-block;
        line-height: 80px;
        vertical-align: top;
        font-size: 18px;
        padding-left: 10px;
    }
    .mid{
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding-top: 20px;
    }
    .mid .ed-header{
        width: 100%;
        height: auto;
        background-color: #ffffff;
    }
    .ed-header .ed-filter{
        width: 100%;
        height: 80px;
        padding: 20px;
    }
    .ed-header .ed-link{
        width: 100%;
        height: 60px;
        padding: 20px;
        font-size: 14px;
    }
    .ed-header .ed-link .link1{
        display: inline-block;
        width: auto;
        height: 100%;
        color: #409eff;
        margin-right: 10px;
        vertical-align: top;
    }
    .ed-header .ed-link .link2{
        display: inline-block;
        max-width: 300px;
        height: 100%;
        color: #409eff;
        margin-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: top;
    }
    .footer{
        color: #666666;
        text-align: center;
        line-height: 114px;
    }
    .access-data{width: 1200px;height: 100px;margin-top: 30px;font-size: 0;}
    .access-data .ad-item{display: inline-block!important;width: 230px;height: 100px;vertical-align: top;background-color: #ffffff;position: relative;padding-left: 120px;}
    .access-data .ad-item.middle{margin: 0 75px;}
    .access-data .ad-item .l-icon{width: 100px;height: 100px;position: absolute;top: 0;left: 0;text-align: center;line-height: 100px;color: #ffffff;}
    .access-data .ad-item .l-icon i{font-size: 38px;}
    .access-data .ad-item .l-icon.bg-blue{background-color: #008df2;}
    .access-data .ad-item .l-icon.bg-green{background-color: #07cc00;}
    .access-data .ad-item .l-icon.bg-red{background-color: #ff4019;}
    .access-data .ad-item .m-data{width: 100%;height: 100%;}
    .access-data .ad-item .m-data .m-text{width: 100%;height: 40px;line-height: 50px;font-size: 14px;}
    .access-data .ad-item .m-data .m-num{width: 100%;height: 60px;line-height: 48px;font-size: 36px;}
    .chart-box1{width: 1160px;height: 440px;padding: 20px;font-size: 0;margin-top: 30px;background-color: #ffffff;}
    .chart-box2{width: 1160px;height: 740px;padding: 20px;font-size: 0;margin-top: 30px;background-color: #ffffff;}
    .chart-box1 .pie-chart{width: 580px;height: 440px;display: inline-block;vertical-align: top;}
    .chart-box1 .bar-chart{width: 580px;height: 440px;display: inline-block;vertical-align: top;}
    .chart-box1 .bar-chart .title{width: 100%;height: 30px;font-weight: bolder;font-size: 18px;color: #333333;}
    .chart-box1 .bar-chart .subtext{width: 100%;height: 20px;font-size: 12px;color: #aaaaaa;}
    .chart-box1 .bar-chart .progress{width: 100%;height: 390px;}
    .chart-box1 .bar-chart .progress .lab{width: 100%;height: 52px;line-height: 52px;font-size: 14px;}
    .record-box{width: 1160px;padding: 20px;margin-top: 30px;background-color: #ffffff;}
    .record-box .title{width: 100%;height: 30px;font-weight: bolder;font-size: 18px;color: #333333;}
    .record-box .subtext{width: 100%;height: 20px;font-size: 12px;color: #aaaaaa;}
    .record-box .content{width: 100%;height: auto;}
    .record-box .pagebar{width: 100%;height: 52px;margin-top: 20px;}
</style>
